$(function() {

//==========================================================================
// MODULE STATE
//==========================================================================

/**
 * The components.
 *
 * jQuery collection of section nodes that map to the component instances.
 *
 * @type       {jQuery}
 */
var $components;

//==========================================================================
// ENTRY POINT
//==========================================================================

init();

//==========================================================================
// INIT
//==========================================================================

//-----

function init() {
    // init module state
    initModuleState();

    // if there are no related components on the page, return
    if (!$components.length) return;

    // when the scroll height changes, update the value
    $window.on('resize', updateState);

    // for each component, do stuff
    __($components).each(manageComponent);
}

//-----

//==========================================================================
// FUNCTIONS
//==========================================================================

//-----

function initModuleState() {
    $components = $('section.contenido-destacados-v2');
}

//-----

function manageComponent(component) {
    var $component = $(component);
    var lastIsDesktop = $node.data('last-is-desktop');
    var currIsDesktop = window.innerWidth > media.tablet;

    adjustPictureToTopRightSide($component);

    $(window).on('resize', function(event) {
        if (currIsDesktop !== lastIsDesktop) {
            adjustPictureToTopRightSide($component, currIsDesktop,
                lastIsDesktop);
        }
    });

    $node.data('last-is-desktop', currIsDesktop);
}

//-----

function adjustPictureToTopRightSide($component, currIsDesktop,
        lastIsDesktop) {

    var $picture = $component.find('picture');
    var $rightSideTop = $component.find('.right-side.top');

    if (lastIsDesktop) {
        // TODO: we can't use inline style because that would brack the
        // bg-center-img plugin...
    }
}

//-----

});
